import React from 'react';
import { ViewRFI } from 'records/interactions/ViewRFI';
import { RFI, RFIId } from 'records/RFI';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps {
  rfiId: RFIId;
}

class RFIDeepLink extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    const { appState, actions, rfiId } = props;

    const nextRFI = appState.rfis.get(rfiId, new RFI());

    const currentlyOpenRFIInteraction = appState.interactions.find(
      (i) => i.type === 'ViewRFI'
    );

    if (currentlyOpenRFIInteraction) {
      const nextInteraction = (currentlyOpenRFIInteraction as ViewRFI).set(
        'rfi',
        nextRFI
      );

      actions.updateInteraction(nextInteraction);
    } else {
      const interaction = new ViewRFI({
        rfi: nextRFI,
      });

      actions.createInteraction(interaction);
    }
  }

  render(): React.ReactNode {
    return null;
  }
}

export default withAppStore<Props>(RFIDeepLink);
